export default {
      id: "placeholder-usage",
      viewBox: "0 0 20 29",
      url: __webpack_public_path__ + "img/icons.svg#placeholder",
      toString: function () {
        return this.url;
      }
    }